import React from "react";
import { format, fromUnixTime } from "date-fns";
import { DayProps } from "react-native-gifted-chat";
import areMessagesSameDay from "./areMessagesSameDay";
import { FormattedChatMessage } from "../../app/types";

const GiftedChatDay = ({
  currentMessage,
  previousMessage,
}: DayProps<FormattedChatMessage>) => {
  if (!currentMessage || areMessagesSameDay(currentMessage, previousMessage)) {
    return null;
  }

  return (
    <div>
      <span>
        {format(
          fromUnixTime(currentMessage.createdAt as number),
          "MMMM do, yyyy",
        )}
      </span>
      <style jsx>{`
        span {
          color: grey;
          font-size: 0.8rem;
          font-weight: bold;
          padding: 15px 0;
        }
        div {
          display: flex;
          justify-content: center;
          align-items: center;
        }
      `}</style>
    </div>
  );
};

export default GiftedChatDay;
